import { cities, districts } from '../pages/Flat/components/Form/constant'

export const getCityText = (city: string) => {
  return cities.find(c => c.value === city)?.label
}

export const getStreetText = (address) => {
  if (!address) {
    return ''
  }
  return `${address.street}, ${address.streetNumber}`
}

export const getDistrictText = district => {
  const label = districts.find(d => d.value === district)?.label
  return label ? `${label}` : ''
}
